var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("SearchableDocumentsList", {
        attrs: {
          userFullName: _vm.contractorFullName,
          query: _vm.query,
          companyId: _vm.companyId,
          currentUser: _vm.currentUser,
          extraInfoHidden: "",
        },
        scopedSlots: _vm._u([
          {
            key: "emptyListActions",
            fn: function () {
              return [
                _c(
                  "p",
                  {
                    staticClass: "text-md my-20 text-primary-black text-center",
                    staticStyle: { width: "100%" },
                  },
                  [_vm._v("There are currently no documents.")]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "actions",
            fn: function ({ refetchDocuments }) {
              return [
                _c("UploadDocument", {
                  staticClass: "flex justify-end relative adjustBottom",
                  attrs: {
                    attachedToUserId: _vm.managerUserId,
                    companyId: _vm.companyId,
                    variant: "transparent",
                    currentUserParent: _vm.currentUser,
                    currentUserId: _vm.currentUser.id,
                  },
                  on: { documentAdded: refetchDocuments },
                }),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }